// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-overlay.v-dialog .vss-movable {\n  cursor: grab;\n}\n.v-overlay.v-dialog .vss-movable:hover {\n  background-color: #eee;\n}\n.v-overlay.v-dialog .vss-movable:active {\n  cursor: grabbing;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
